import _BaseAPIService from "../../_BaseAPIService";

const apiService = _BaseAPIService.instance;
const slug = "api";
const ItemService = {
  getList: async ({ pageNumber, pageSize, itemName, categoryId }) => {
    // Build query params dynamically
    const params = new URLSearchParams();

    if (pageNumber) params.append("pageNumber", pageNumber);
    if (pageSize) params.append("pageSize", pageSize);
    if (itemName) params.append("itemName", itemName); // only added if not null/empty
    if (categoryId) params.append("categoryId", categoryId);

    const response = await apiService.get(
      `/${slug}/menuitem?${params.toString()}`
    );
    console.log("🚀 ~ getList: ~ response:", response);

    return response.data;
  },

  create: async ({ data }) => {
    const response = await apiService.post(`/${slug}/menuitem`, data);
    return response.data;
  },
  detail: async (id) => {
    const response = await apiService.get(`/${slug}/menuitem/${id}`);
    return response.data;
  },
  delete: async (id) => {
    const response = await apiService.delete(`/${slug}/menuitem/${id}`);
    return response.data;
  },
  update: async (id, updatedData) => {
    try {
      const response = await apiService.put(
        `/${slug}/menuitem/${id}`,
        updatedData
      );
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
};

export default ItemService;
